module.exports = __webpack_public_path__ + "static/media/company-logo-white.72ae964c.png";